/**
 * Copyright 2021 mmmint.ai info@mmmint.ai - All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential to MMM Intelligence UG (haftungsbeschränkt).
 */

/**
 * The status of an attachment request
 */
export enum AttachmentRequestStatusEnum {
  /**
   * Request has been created
   */
  CREATED = "created",

  /**
   * Request has been sent to the recipient
   */
  SENT = "sent",

  /**
   * Request has been opened by the recipient
   */
  OPENED = "opened",

  /**
   * Request has been completed by the recipient
   */
  COMPLETED = "completed"
}
